"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Clock = _interopRequireDefault(require("./Clock"));
var _ProductsCounter = _interopRequireDefault(require("./ProductsCounter"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
var HitProductPage = function HitProductPage() {
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: 260,
      color: "white",
      backgroundColor: "main",
      display: "flex",
      px: "s11",
      marginBottom: "s7"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      flex: "display",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      mt: "s8"
    }
  }, __jsx(_Clock["default"], null), __jsx(_ProductsCounter["default"], {
    progressActive: true
  })));
};
var _default = HitProductPage;
exports["default"] = _default;